import axios from '../config'
import { micles_api } from '../baseURL'

export default {
    //获取微课信息
    getMicroLesson(id) {
        return axios.get(`${micles_api}/microLessonModel/${id}`)
    }
}